module.exports = __webpack_public_path__ + "static/media/marek2.3208dd8d.png";